import { IABTestContext, LeadToMeetingAbTest } from 'config/abTests';

// Whitelist source: "פרויקטים ל-L2M" sheet linked in ILDEV-12332.
export const LEAD_TO_MEETING_PROJECT_IDS: string[] = [
  // azorim
  'שלמה_המלך_4_חיפה',
  'שרת_משה_30_חולון',
  'מתחם_ויצמן_הרצליה',
  'ארלוזורוב_84_רמת_גן',
  'מגרשים_1A_1B_בשכונת_אמת_המים_ירושלים',
  'השבטים_בת_ים',
  'שלום_הגליל_נהריה',
  'ההסתדרות_9_13_נתניה',
  'בן_גוריון_מערב_שער_העיר_גבעת_שמואל',
  'מגרשים_204_205_בשכונת_אגמים_אשקלון',
  'Central_Park_17',
  'שדרות_בנימין_מגרשים_1410_1411_נתניה',
  'AZORIM_HAZUK_NETANYA',
  'שלום_יהודה_20_26_ירושלים',
  'VitzmaSokolovNetanya',
  'שדרות_הרצל_67_ירושלים',
  'ויצמן_בארי_נתניה',
  // verbatim from the source sheet — unlike the other ids this one uses
  // spaces and a comma, not slug underscores
  'יצחק אלחנן 4, רמת השרון',
  'ששת_הימים_48_תל_אביב_יפו',
  // kofmanGroup
  'הכרם_6_פתח_תקווה',
  'מכנס_גד_28_פתח_תקווה',
  'ברטונוב_יהושע_6_פתח_תקווה',
  'עין_גנים_12_פתח_תקווה',
  'קטרוני_12_פתח_תקווה',
  'KALISHER_14_PETAH_TIKVA',
  'KISH_18_PETAH_TIKVA',
  'משה_וילנסקי_55_רעננה',
  'פנקס_5_פתח_תקווה',
  'YESOD_HAMAALA_55_TEL_AVIV',
  'זלטופולסקי_10-12_תל_אביב',
  'אפשטיין_1_תל_אביב_יפו',
  'רוטשילד_180_פתח_תקווה',
  // electra
  'אלקטרה_מתחם_האלף_מגרש_101_ראשון_לציון',
  'אכזיב',
  'הסרגל_9_הוד_השרון',
  'אלקטרה_בשכונת_דרום_מערב_בת_ים',
  // almiGroup
  'בילטמור_10_תל_אביב_יפו',
  'בן_שפרוט_13_15_תל_אביב',
  'בני_דן_48_תל_אביב_יפו',
  'הזוהר_21_תל_אביב',
  'Lessin_4_Tel_Aviv_Yafo',
  'הלסינקי_8_תל_אביב_יפו',
  'מרים_החשמונאית_28_30_תל_אביב',
  'הרב_צירלסון_14_תל_אביב_יפו',
  'רמברנדט_11_תל_אביב_יפו',
  'שטריקר_3_תל_אביב',
  // staging-only developer (auto-dev01) for QA of the L2M widget
  'auto-proj-28-1',
];

const whitelistedProjectIds: Set<string> = new Set(LEAD_TO_MEETING_PROJECT_IDS);

export const isLeadToMeetingWhitelistedProject = (projectId: string): boolean => (
  Boolean(projectId) && whitelistedProjectIds.has(projectId)
);

export const isLeadToMeetingEnabled = (abTests: IABTestContext, projectId: string): boolean => (
  Boolean(abTests) && abTests.leadToMeeting === LeadToMeetingAbTest.modeB && isLeadToMeetingWhitelistedProject(projectId)
);
